import React from 'react';
import SubjectReviewActivityLogGrid from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/subject-review-activity-log-grid';

type Props = {
    studyRef: string;
    reviewId: number;
};

const SMSelectedReviewSectionActivityTab = ({ studyRef, reviewId }: Props) => {
    return <SubjectReviewActivityLogGrid studyRef={studyRef} reviewId={reviewId} />;
};

export default SMSelectedReviewSectionActivityTab;
